<template>
  <div class="csv-tag-table">
    <el-tabs v-model="activeTab">
      <!-- Unmatched Creator Tags -->
      <el-tab-pane :label="`Unmatched Creator Tags (${creatorTags.length})`" name="tags"  v-if="creatorTags.length>0">
        <div v-if="activeTab === 'tags'">
          <el-table :data="creatorTags" style="width: 100%" max-height="50vh">
            <el-table-column prop="tag" label="Creator Tags"/>
            <el-table-column prop="validation" label="Validation">
              <template #default="scope">
                <span style="color: red">{{ scope?.row?.validation }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <!-- Unmatched Creators -->
      <el-tab-pane :label="`Unmatched Creators (${unmatchedCreators.length})`" name="creators" v-if="unmatchedCreators.length>0">
        <div v-if="activeTab === 'creators'">
          <el-table :data="unmatchedCreators" style="width: 100%" max-height="50vh">
            <el-table-column prop="member_id" label="Member ID" />
            <el-table-column prop="anchor_creator_full_name" label="Name" />
            <el-table-column prop="validation" label="Validation">
              <template #default="scope">
                <span style="color: red">{{ scope?.row?.validation }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>

      <!-- Other Errors -->
      <el-tab-pane :label="`Other errors (${otherErrors.length})`" name="errors" v-if="otherErrors.length>0">
        <div v-if="activeTab === 'errors'">
          <el-table :data="otherErrors" style="width: 100%" max-height="50vh">
            <el-table-column prop="member_id" label="Member ID" />
            <el-table-column prop="anchor_creator_full_name" label="Name" />
            <el-table-column prop="added_tag_text_json" label="Tags to add" />
            <el-table-column prop="removed_tag_text_json" label="Tags to remove" />

            <el-table-column label="Validation">
              <template #default="scope">
                <span style="color: red">{{ scope.row.validation }}</span>
              </template>
            </el-table-column>

            <el-table-column label="" width="50" align="center">
              <template #default="scope">
                <svg-icon class="remove-svg" name="remove" @click="handleRemove(scope.row)"/>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>

  <el-dialog v-model="openModal" :show-close="false" @close="closeUploadDialog" class="upload-tag-dialog" width="600">
    <div class="title">
      <h2>Please resolve "other errors" to continue</h2>
    </div>
    <div class="content"><p>We found some other issues that require you to take action</p></div>
    <div class="btn-box">
      <el-button @click="openModal = false" type="primary">Back</el-button>
    </div>
  </el-dialog>
</template> 

<script setup>
import { ref, onMounted, computed, getCurrentInstance, } from 'vue';
import { useStore } from 'vuex';
import { ElTable, ElTableColumn, ElTabPane, ElTabs, ElButton, ElDialog } from 'element-plus';
import { useNotification } from '@/components/ui/notification';

const { openNotBottom } = useNotification();
const activeTab = ref('tags');
const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
});
const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const openModal = ref(false);
const emit = defineEmits(['duplicate_removed']);
// --- 假資料 ---
const creatorTags = ref([]);

const unmatchedCreators = ref([]);

const otherErrors = ref([]);
//++++++++++++++++++++++++++++
const startHandleData = () => {
  console.log('props.data', props.data);
  otherErrors.value=[];
  props.data.duplicate_member_id_rows.forEach(row => {
    row.validation = 'Duplicates';
    otherErrors.value.push(row);
  });

  creatorTags.value=[];
  props.data.not_matched_tag_text_array.forEach(tag => {
    let row={};
    row.tag= tag;
    row.validation = 'This Creator Tag hasn’t been added yet';
    creatorTags.value.push(row);
  });
  props.data.not_valid_tag_text_array.forEach(creator => {
    let row={};
    row.tag= creator;
    row.validation = 'Formatting issue';
    creatorTags.value.push(row);
  });

  unmatchedCreators.value=[];
  props.data.unmatch_member_id_rows.forEach(creator => {
    creator.validation = 'No creator found';
    unmatchedCreators.value.push(creator);
  });

  activeTab.value = creatorTags.value.length > 0 ? 'tags': unmatchedCreators.value.length>0 ?'creators':'errors';
};

const handleRemove = (row) => {
  // Remove the selected row from otherErrors
  let form_data = new FormData();
  form_data.append('batch_creator_tag_update_row_ids[]', row.id);
  ajax
    .post('/batch-tag-update/remove-rows', form_data)
    .then(() => {
        const index = otherErrors.value.indexOf(row);
        if (index > -1) {
          otherErrors.value.splice(index, 1);
          openNotBottom('Removed successfully', 'success');
          emit('duplicate_removed', otherErrors.value);
        }
    })
    .catch((error) => {
      console.error('Error removing row:', error);
      openNotBottom('Failed to remove the row', 'error');
    });

};

const openAlertDialog = () => {
  openModal.value = true;
};

onMounted(() => {
  startHandleData();
});

defineExpose({
  openAlertDialog,
});
</script>

<style lang="scss">
.csv-tag-table {
  margin: 8px 0;

  .remove-svg{
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
}
</style>
